import { clsx } from 'clsx'
import { type FC } from 'react'

import { type OfferV11 } from '@redteclab/api/clients/bully'

import { Experiment } from '../../../../../../experiments/components/Experiment'
import { ExperimentVariant } from '../../../../../../experiments/components/ExperimentVariant'
import { EXPERIMENT_NAME_MARKETPLACE_HARMONISATION_PDP } from '../../../../../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../../../../../experiments/model/EXPERIMENT_VARIATION'
import { productAccessorGetSellerPromotionFromOffer } from '../../../../../model/productAccessor/productAccessorGetSellerPromotionFromOffer'
import { useProductPageContext } from '../../../../productPageContext'
import { ProductSellerPromotionFlag } from '../../../../ProductSellerPromotionFlag/ProductSellerPromotionFlag'
import { ProductHeadGenericLabel } from '../../ProductHeadGenericLabel/ProductHeadGenericLabel'

import { ExperimentMarketplaceSellerPromotionHarmonisation } from './ExperimentMarketplaceSellerPromotionHarmonisation'

type ProductHeadSellerPromotionLabelProps = {
  className?: string
  offer: OfferV11 | undefined
}

export const ProductHeadSellerPromotionLabel: FC<
  ProductHeadSellerPromotionLabelProps
> = ({ className, offer }) => {
  const { product } = useProductPageContext()

  if (!offer) {
    return null
  }

  const sellerPromotion = productAccessorGetSellerPromotionFromOffer(offer)

  if (!sellerPromotion) {
    return null
  }

  return (
    <Experiment names={[EXPERIMENT_NAME_MARKETPLACE_HARMONISATION_PDP]}>
      <ExperimentVariant name={EXPERIMENT_VARIATION.DEFAULT}>
        <ProductHeadGenericLabel
          className={clsx(
            'border-light-primary-strong bg-light-brand-medium',
            className,
          )}
          data-qa-id="product-label-seller-promotion"
        >
          <ProductSellerPromotionFlag sellerPromotion={sellerPromotion} />
        </ProductHeadGenericLabel>
      </ExperimentVariant>
      <ExperimentVariant name={EXPERIMENT_VARIATION.V1}>
        <ExperimentMarketplaceSellerPromotionHarmonisation
          offer={offer}
          product={product}
          sellerPromotion={sellerPromotion}
        />
      </ExperimentVariant>
      <ExperimentVariant name={EXPERIMENT_VARIATION.V2}>
        {null}
      </ExperimentVariant>
    </Experiment>
  )
}
